import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Landing from "../components/landing/landing"
import ShutdownBanner from '../components/ceasing-operations/shutdown-banner'

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <ShutdownBanner/>
    <Landing/>
  </Layout>

)

export default IndexPage